import { HlAppMode } from './hl-app-mode'

const iosCustomUrlSchemeBase = process.env.HOTELLOVERS_APP_URL_SCHEME || 'jp.mclr'

// Branded Typesを使用して、HlAppDeeplink型を定義
export type HlAppDeeplink = string & { readonly __brand: 'HlAppDeeplink' }
export const urlIsHlAppDeeplink = (url: string): url is HlAppDeeplink => url.startsWith(iosCustomUrlSchemeBase)

const createDeeplink = (path: string): HlAppDeeplink => `${iosCustomUrlSchemeBase}://${path}` as HlAppDeeplink

export const iosCustomUrlSchemes = {
  // WebViewを閉じる
  close: createDeeplink('keep'),
  // カートに遷移
  cart: createDeeplink('cart'),
  // サンクスページ（注文完了画面）に遷移
  orderComplete: createDeeplink('cart/thanks'),
  // マイページに遷移
  mypage: createDeeplink('mypage'),
  /**
   * 外部ブラウザで開く
   * 例: webview?path=/hlapp/external_account_association/line/start&openExternalBrowser=true
   *
   * アプリ側は以下のように動作する：
   * - アプリの認証状態をもとにo, hashを取得する
   * - pathがo, hashを解釈できるパス (/hlapp/direct/*) であればそのままo, hashを付けて開く
   * - pathがo, hashを解釈できないパスの場合、 /nc/auth/auto-login を経由して path を開く
   */
  createOpenExternalBrowser: (path: string) => createDeeplink(`webview?path=${path}&openExternalBrowser=true`),
}

export const navigateToHlAppDeeplink = (url: HlAppDeeplink) => {
  executeWithDeeplinkHandlerCheck(
    handler => handler.postMessage(url),
    () => { location.href = url }
  )
}

export const navigateToHlAppDeeplinkWithDelay = (url: HlAppDeeplink, ms: number) => {
  setTimeout(() => navigateToHlAppDeeplink(url), ms)
}

/**
 * location.hrefによるdeeplinkへの遷移が特にWebViewでは安定しないため、
 * - iOSホテラバアプリで開かれていたら、webkit.messageHandlersを使用する
 * - そうでなければlocation.hrefで遷移する
 *
 * 内部的には、アプリのUAであるか、window.webkit.messageHandlers.deeplinkが存在するかチェックして、
 * 存在したらwhenAvailable、存在しなかったらwhenNotAvailableを実行する
 *
 * @param whenAvailable webkit.messageHandlers.deeplinkが利用可能な場合のコールバック
 * @param whenNotAvailable webkit.messageHandlers.deeplinkが利用できない場合のコールバック
 *
 * @see https://github.com/Everforth/growthpalette-front/issues/8526
 */
const executeWithDeeplinkHandlerCheck = (
  whenAvailable: (deeplinkHandler: DeeplinkHandler) => void,
  whenNotAvailable: () => void
) => {
  if (
    HlAppMode.isViewedInHlAppWebView &&
    window.webkit &&
    window.webkit.messageHandlers &&
    window.webkit.messageHandlers.deeplink
  ) {
    whenAvailable(window.webkit.messageHandlers.deeplink)
  } else {
    whenNotAvailable()
  }
}

// postMessage: (message: string) => void; として解決される
type DeeplinkHandler = NonNullable<NonNullable<NonNullable<typeof window.webkit>['messageHandlers']>['deeplink']>
